// extracted by mini-css-extract-plugin
module.exports = {"container":"Model_container__2ccgp","model":"Model_model__3iKH3"};